<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
input.mx-input {
  height: 40px !important;
}
.footer-text {
  font-family: "Prompt", sans-serif;
  font-size: 14px;
  margin-left: 35.7rem;
}
.line-paper {
  font-weight: 500;
  font-size: 16px;
}
</style>

<template>
  <div>
    <v-container style="background: #cefffa86">
      <div v-if="wasteDocument != ''">
        <v-layout class="d-flex justify-end mb-2">
          <div v-if="isMobile()"></div>
          <div v-else>
            <v-btn
              color="primary"
              elevation="0"
              large
              dark
              class="mr-4 px-10"
              @click="printDoc()"
            >
              <div><v-icon left>mdi-plus</v-icon>พิมพ์เอกสาร</div>
            </v-btn>
          </div>
        </v-layout>

        <div v-if="isMobile() && wasteDocument">
          <v-col class="line-paper ma-0">
            <div>
              <v-card>
                <v-col cols="12">
                  <div>เลขที่ ตช. : {{ $route.params.tra_id }}</div>
                </v-col>
              </v-card>
              <v-card class="mt-3">
                <v-col cols="12" sm="6">
                  <div class="d-flex justify-center font-weight-black">
                    ข้อมูลผู้เก็บขน
                  </div>
                  <v-divider class="my-2 mx-5"></v-divider>

                  <div class="my-1">ผู้เก็บขน : {{ conpany_profile.NAME }}</div>

                  <div class="my-1">
                    เบอร์โทร : {{ conpany_profile.MOBILE_TEL }}
                  </div>
                  <div class="my-1">
                    รถขนมูลฝอย : {{ wasteDocument[0].CAR_TYPE | setTypeCar }}
                  </div>
                  <div class="my-1">
                    เลขทะเบียน : {{ wasteDocument[0].CAR_NUMBER | checkData }}
                  </div>
                  <div class="my-1">
                    ชื่อคนขับรถ : {{ wasteDocument[0].PD_NAME | checkData }}
                    {{ wasteDocument[0].PD_LAST | checkData }}
                  </div>
                  <div class="my-1">
                    ชื่อพนักงานเก็บขน : {{ wasteDocument[0].PC_NAME }}
                    {{ wasteDocument[0].PC_LAST }}
                  </div>
                </v-col>
              </v-card>
              <v-card class="mt-3">
                <v-col cols="12" sm="6">
                  <div class="d-flex justify-center font-weight-black">
                    ข้อมูลแหล่งกำเนิด
                  </div>
                  <v-divider class="my-2 mx-5"></v-divider>
                  <div class="my-1">
                    วันที่เข้าเก็บ : {{ wasteDocument[0].W_I | formatDate }} น.
                  </div>
                  <div class="my-1">ชื่อ : {{ wasteDocument[0].C_N }}</div>
                  <div class="my-1">
                    เวลาเข้าเก็บ : {{ wasteDocument[0].W_I | formatTime }} น.
                  </div>
                  <div class="my-1">
                    เวลาออก : {{ wasteDocument[0].W_O | formatTime }} น.
                  </div>
                  <div class="my-1">
                    ปริมาณมูลฝอย : {{ wasteDocument[0].W_W }} กก.
                  </div>
                  <!-- <div class="my-1">
                    ชื่อ จนท.ส่งมอบ : {{ wasteDocument[0].P_N | checkData }}
                  </div> -->

                  <div class="my-5 mx-3">
                    <v-row>
                      ลายเซ็น:
                      <v-img
                        class="ml-10"
                        max-height="100"
                        max-width="100"
                        :src="getUrlOrigin"
                      ></v-img>
                    </v-row>
                  </div>
                  <v-expansion-panels>
                    <v-expansion-panel>
                      <v-expansion-panel-header>
                        รายละเอียด เพิ่มเติม
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <div class="my-1">
                          ติดเชื้อ
                          <div class="ml-3">
                            ขยะติดเชื้อ :
                            {{ wasteDocument[0].TD2_1_WB | delimeter }} กก.
                          </div>
                          <div class="ml-3">
                            เข็ม :
                            {{ wasteDocument[0].TD2_2_WB | delimeter }} กก.
                          </div>
                          <div class="ml-3">
                            ชิ้นเนื้อ :
                            {{ wasteDocument[0].TD2_3_WB | delimeter }} กก.
                          </div>
                          <div class="ml-3">
                            ติดเชื้อ อื่นๆ :
                            {{ wasteDocument[0].TD2_4_WC | delimeter }} กก.
                          </div>
                        </div>
                        <div class="my-1">
                          เคมี
                          <div class="ml-3">
                            เคมี :
                            {{ wasteDocument[0].TD1_1_WA | delimeter }} กก.
                          </div>
                          <div class="ml-3">
                            ไซลีน :
                            {{ wasteDocument[0].TD1_2_WA | delimeter }} กก.
                          </div>
                          <div class="ml-3">
                            แอมป์ยา :
                            {{ wasteDocument[0].TD1_3_WA | delimeter }} กก.
                          </div>
                          <div class="ml-3">
                            เคมี อื่นๆ :
                            {{ wasteDocument[0].TD1_4_WB | delimeter }} กก.
                          </div>
                        </div>

                        <div class="my-1">
                          อันตราย
                          <div class="ml-3">
                            อันตราย :
                            {{ wasteDocument[0].TD3_1_WC | delimeter }} กก.
                          </div>
                          <div class="ml-3">
                            อันตราย อื่นๆ :
                            {{ wasteDocument[0].TD3_2_WC | delimeter }} กก.
                          </div>
                        </div>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-card>
              <v-card class="mt-3">
                <v-col cols="12" sm="6">
                  <div class="d-flex justify-center font-weight-black">
                    ข้อมูลแหล่งกำจัด
                  </div>
                  <v-divider class="my-2 mx-5"></v-divider>
                  <div class="my-1">
                    สถานที่กำจัด : {{ wasteDocument[0].D_N | checkData }}
                  </div>
                  <div class="my-1">
                    โทรศัพท์ : {{ wasteDocument[0].D_P | checkData }}
                  </div>
                  <div class="my-1">
                    ที่อยู่ : {{ wasteDocument[0].D_A | checkData }}
                  </div>
                  <div class="my-1">
                    ชื่อเจ้าหน้าที่โรงกำจัด :
                    {{ wasteDocument[0].D_O | checkData }}
                  </div>
                  <div class="my-5 mx-3">
                    <v-row>
                      ลายเซ็น :
                      <v-img
                        class="ml-10"
                        max-height="100"
                        max-width="100"
                        :src="getUrlRemoval"
                      ></v-img>
                    </v-row>
                  </div>
                  <div class="my-1">
                    โทรศัพท์ : {{ wasteDocument[0].D_O_P | checkData }}
                  </div>
                  <div class="my-1">
                    ว.ด.ป ที่รับมอบ : {{ wasteDocument[0].D_D | formatDate }} น.
                  </div>
                </v-col>
              </v-card>
              <v-card class="mt-3">
                <v-col cols="12" sm="6">
                  <div class="d-flex justify-center">
                    ประวัติการเคลื่อนย้ายมูลฝอย
                  </div>
                  <v-divider class="my-2 mx-5"></v-divider>
                  <div class="my-1">
                    1. แหล่งกำเนิด
                    <div class="ml-3">
                      เข้า {{ wasteDocument[0].W_I | formatDate }} น. --> ออก
                      {{ wasteDocument[0].W_O | formatDate }} น.
                    </div>
                    <div class="ml-3">
                      {{ wasteDocument[0].C_N | checkData }} -->
                      {{ wasteDocument[0].CAR_NUMBER }}
                    </div>
                  </div>
                  <div class="my-1">
                    2. เคลื่อนย้ายมูลฝอย
                    <div v-for="(item, index) in wasteDocument" :key="index">
                      <!-- {{ index }} -->
                      <div class="ml-3" v-if="index > 0">
                        <div v-if="index == 1">
                          {{ item.TIMESTAMP | formatDate }} น. <br />

                          {{ item.CAR_NUMBER }} เปลี่ยนถ่ายรถ
                          {{ item.CSI_CAR_N }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="my-1">
                    3. โรงกำจัด
                    <div v-for="(item, index) in wasteDocument" :key="index">
                      <!-- {{index}} {{Object.keys(wasteDocument).length-1}} -->
                      <div
                        v-for="(item2, index2) in wasteDocument"
                        :key="index2"
                      >
                        <div v-if="index != 0">
                          <div
                            v-if="
                              index == Object.keys(wasteDocument).length - 2
                            "
                          >
                            <div
                              v-if="
                                index2 == Object.keys(wasteDocument).length - 1
                              "
                            >
                              <div class="ml-3">
                                {{ item2.TIMESTAMP | formatDate }} น.
                              </div>
                              <div class="ml-3">
                                {{ item.CSI_CAR_N }} -- {{ item2.CSI_CAR_N }}
                                {{ item2.D_N | checkData }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-card>
            </div>
          </v-col>
        </div>

        <div v-else>
          <v-col class="line-paper">
            <v-row>
              <v-col>
                <div class="mt-10 ml-10">
                  เลขที่ : {{ $route.params.tra_id }}
                </div>
                <div class="mt-2 ml-10">
                  วันที่พิมพ์ : {{ nowDate | formatDate }} น.
                </div>
              </v-col>
              <v-col>
                <div
                  class="d-flex justify-center"
                  style="font-size: 24px !important"
                >
                  เอกสาร ตช.
                </div>
              </v-col>
              <v-col class="d-flex justify-end mr-16">
                <div>
                  <qrcode-vue
                    :value="this.$global_link + this.$route.fullPath"
                    :size="110"
                    level="H"
                  ></qrcode-vue>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="mr-2 ml-10">
                <v-row>
                  <v-col>
                    <div>
                      ชื่อเอกชน/ผู้เก็บขน ที่อยู่ : {{this.$AppName.CoLtd}} 
                    </div>
                  </v-col>
                  <v-col>
                    <div>โทรศัพท์ : 081-6949845</div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div>
                      รถขนมูลฝอย : {{ wasteDocument[0].CAR_TYPE | setTypeCar }}
                    </div>
                  </v-col>
                  <v-col>
                    <div>
                      เลขทะเบียน : {{ wasteDocument[0].CAR_NUMBER | checkData }}
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div>
                      ชื่อคนขับรถ : {{ wasteDocument[0].PD_NAME | checkData }}
                      {{ wasteDocument[0].PD_LAST | checkData }}
                    </div>
                  </v-col>
                  <v-col>
                    <div>
                      โทรศัพท์ : {{ wasteDocument[0].PD_PHONE | checkData }}
                    </div>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div>
                      ชื่อพนักงานเก็บขน : {{ wasteDocument[0].PC_NAME }}
                      {{ wasteDocument[0].PC_LAST }}
                    </div>
                  </v-col>
                  <v-col>
                    <div>
                      โทรศัพท์ : {{ wasteDocument[0].PC_PHONE | checkData }}
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="mx-10">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th>ชื่อแหล่งกำเนิด</th>
                        <th>เวลาเข้าเก็บ</th>
                        <th>เวลาออก</th>
                        <th>ปริมาณมูลฝอย (กก.)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          {{ wasteDocument[0].C_N }}
                        </td>
                        <td>{{ wasteDocument[0].W_I | formatTime }} น.</td>
                        <td>{{ wasteDocument[0].W_O | formatTime }} น.</td>
                        <td>{{ wasteDocument[0].W_W }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>

            <v-divider class="my-2 mx-10"></v-divider>
            <v-row>
              <v-col class="ml-10">
                <v-row>
                  <!-- <v-col>
                    <div>
                      ชื่อ จนท. ผู้ส่งมอบมูลฝอย : -
                      {{ wasteDocument[0].P_N | checkData }}
                    </div>
                  </v-col> -->
                  <v-col>
                    <div>
                      ลายเซ็น :
                      <v-img
                        class="ml-16 mt-n12"
                        max-height="100"
                        max-width="100"
                        :src="getUrlOrigin"
                      ></v-img>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="my-2 mx-10"></v-divider>
            <v-row>
              <v-col class="my-2 mx-10">
                <v-row>
                  <v-col>
                    สถานที่กำจัด : {{ wasteDocument[0].D_N | checkData }}</v-col
                  >
                  <v-col>
                    โทรศัพท์ : {{ wasteDocument[0].D_P | checkData }}</v-col
                  >
                </v-row>
                <v-row>
                  <v-col>
                    ที่อยู่ : {{ wasteDocument[0].D_A | checkData }}</v-col
                  >
                </v-row>
                <v-row>
                  <v-col>
                    ชื่อเจ้าหน้าที่โรงกำจัด :
                    {{ wasteDocument[0].D_O | checkData }}</v-col
                  >
                  <v-col>
                    <div>
                      ลายเซ็น :
                      <v-img
                        class="ml-16 mt-n12"
                        max-height="100"
                        max-width="100"
                        :src="getUrlRemoval"
                      ></v-img>
                    </div>
                  </v-col>
                  <v-col>
                    โทรศัพท์มือถือ :
                    {{ wasteDocument[0].D_O_P | checkData }}</v-col
                  >
                </v-row>
                <v-row>
                  <v-col>
                    <div>
                      ว.ด.ป ที่รับมอบ :
                      {{ wasteDocument[0].D_D | formatDate }} น.
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider class="my-2 mx-10"></v-divider>
            <v-row>
              <v-col class="my-2 mx-10">
                <div style="border-bottom-style: dashed; width: 18%">
                  ประวัติการเคลื่อนย้ายมูลฝอย
                </div>
                <v-row>
                  <v-col>
                    <div>1. แหล่งกำเนิด</div>
                    <v-row class="ml-3">
                      <v-col>
                        <div>{{ wasteDocument[0].W_I | formatDate }} น.</div>

                        <div>
                          {{ wasteDocument[0].C_N | checkData }} --
                          {{ wasteDocument[0].CAR_NUMBER }}
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div>2. เคลื่อนย้ายมูลฝอย</div>
                    <v-row v-for="(item, index) in wasteDocument" :key="index">
                      <!-- {{item}} -->
                      <v-col>
                        <div class="ml-3" v-if="index > 0">
                          <div v-if="index == 1">
                            {{ item.TIMESTAMP | formatDate }} น. <br />

                            {{ item.CAR_NUMBER }} เปลี่ยนถ่ายรถ
                            {{ item.CSI_CAR_N }}
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <div>3. โรงกำจัด</div>
                    <v-row v-for="(item, index) in wasteDocument" :key="index">
                      <!-- {{index}} {{Object.keys(wasteDocument).length-1}} -->
                      <v-col>
                        <div
                          v-for="(item2, index2) in wasteDocument"
                          :key="index2"
                        >
                          <div v-if="index != 0">
                            <!-- index != 0 -->
                            <div
                              v-if="
                                index == Object.keys(wasteDocument).length - 2
                              "
                            >
                              <!-- index == -2 -->
                              <div
                                v-if="
                                  index2 ==
                                    Object.keys(wasteDocument).length - 1
                                "
                              >
                                <!-- index == -1 -->
                                <div class="ml-3">
                                  {{ item2.D_N | checkData }}
                                </div>
                                <div class="ml-3">
                                  {{ item2.TIMESTAMP | formatDate }} น.
                                </div>
                                <div class="ml-3">
                                  {{ item.CSI_CAR_N }} --
                                  {{ item2.CSI_CAR_N }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </v-col>
                      <!-- <div
                        v-if="
                          index != 0 &&
                          index == Object.keys(wasteDocument).length - 1
                        "
                      >
                        <div class="ml-3">
                          {{ item.D_N | checkData }}
                        </div>
                        <div class="ml-3">
                          {{ item.TIMESTAMP | formatDate }} น.
                        </div>
                        <div class="ml-3">
                          {{ item.CAR_NUMBER }} --
                          {{ item.CSI_CAR_N }}
                        </div>
                      </div> -->
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-divider class="my-2 mx-10"></v-divider>
            <v-row>
              <v-col class="my-2 mx-10">
                <v-row>
                  <div style="border-bottom-style: dashed">
                    รายละเอียด เพิ่มเติม
                  </div>
                </v-row>
                <v-row>
                  <v-col class="mt-2">
                    <div>ติดเชื้อ</div>

                    <div class="ml-5 mt-2">
                      ขยะติดเชื้อ :
                      {{ wasteDocument[0].TD2_1_WB | delimeter }} กก.
                    </div>

                    <div class="ml-5 mt-2">
                      เข็ม :
                      {{ wasteDocument[0].TD2_2_WB | delimeter }} กก.
                    </div>

                    <div class="ml-5 mt-2">
                      ชิ้นเนื้อ :
                      {{ wasteDocument[0].TD2_3_WB | delimeter }} กก.
                    </div>
                    <div class="ml-5 mt-2">
                      ติดเชื้อ อื่นๆ :
                      {{ wasteDocument[0].TD2_4_WC | delimeter }} กก.
                    </div>
                  </v-col>
                  <v-col>
                    <div>เคมี</div>

                    <div class="ml-5 mt-2">
                      เคมี :
                      {{ wasteDocument[0].TD1_1_WA | delimeter }} กก.
                    </div>

                    <div class="ml-5 mt-2">
                      ไซลีน :
                      {{ wasteDocument[0].TD1_2_WA | delimeter }} กก.
                    </div>

                    <div class="ml-5 mt-2">
                      แอมป์ยา :
                      {{ wasteDocument[0].TD1_3_WA | delimeter }} กก.
                    </div>

                    <div class="ml-5 mt-2">
                      เคมี อื่นๆ :
                      {{ wasteDocument[0].TD1_4_WB | delimeter }} กก.
                    </div>
                  </v-col>

                  <v-col>
                    <div>อันตราย</div>

                    <div class="ml-5 mt-2">
                      อันตราย :
                      {{ wasteDocument[0].TD3_1_WC | delimeter }} กก.
                    </div>

                    <div class="ml-5 mt-2">
                      อันตราย อื่นๆ :
                      {{ wasteDocument[0].TD3_2_WC | delimeter }} กก.
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="my-2 mx-10"></v-divider>
          </v-col>
        </div>
      </div>
      <div v-else>
        <v-card>
          <v-col cols="12" class="d-flex justify-center">
            <div>ไม่พบข้อมูล</div>
          </v-col>
        </v-card>
      </div>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import pdfMake from "@/assets/build/pdfmake";
import pdfFonts from "@/assets/build/vfs_fonts";
import waste_document from "./pdf/WasteDocument";
import print_document_a5 from "./pdf/printWastDocA5";
import QrcodeVue from "qrcode.vue";
import TableMenuCustomer from "../components/TableMenuCustomer";
export default {
  name: "linkReportDocument",
  components: {
    QrcodeVue,
  },
  data: () => ({
    passData: Array,
    nowDate: new Date(),
    search: "",
    headers: [
      {
        text: "ลำดับ",
        align: "start",
        sortable: false,
        value: "index",
      },
      {
        text: "วันที่",
        align: "start",
        sortable: false,
        value: "Time",
      },
      { text: "เลขที่ ตช.", value: "T_ID" },
      { text: "ชื่อแหล่งผลิต", value: "C_N" },
      { text: "น้ำหนัก", value: "W_W" },
    ],
    wasteDocuments: [],
    search_id: "",
    desserts: [
      {
        name: "Frozen Yogurt",
        calories: 159,
      },
    ],
    getUrlOrigin: "",
    getUrlRemoval: "",
    conpany_profile: "",
  }), 
  computed: {
    wasteDocument() {
      return this.wasteDocuments.map((item, index) => ({
        ...item,
        index: index + 1,
        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
    sumAlls() {
      return this.wasteDocument.map((item) => item.W_W);
    },
  },
  mounted() {
    // this.list_wasteDocument();
    // this.createImg_link();
  },
  created() {
    this.list_wasteDocument();
    this.createImg_link();
    this.list_company_profile();
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2);
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      if (isNaN(x) == false) {
        return x;
      } else {
        return "-";
      }
    },
    formatDate(data) {
      if (data || data == "-") {
        return moment(data)
          .add(543, "years")
          .format("DD/MM/YYYY HH:mm", true);
      } else {
        return "-";
      }
    },
    formatTime(data) {
      if (data || data == "-") {
        return moment(data)
          .add(543, "years")
          .format(" HH:mm ", true);
      } else {
        return "-";
      }
    },
    setTypeCar(data) {
      return data == "1"
        ? "4 ล้อ"
        : data == "2"
        ? "6 ล้อ"
        : data == "3" || data == "4"
        ? " "
        : "-";
    },
    checkData(data) {
      return data != "" ? data : " - ";
    },
  },
  methods: {
    list_company_profile() {
      this.$guest_api
        .get("/get-company-profile")
        .then((response) => {
          if (response) {
            console.log(response.data.data);
            this.conpany_profile = response.data.data[0];
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    list_wasteDocument() {
      let s = this.$route.params.tra_id;
      console.log(s);
      console.log(this.wasteDocument != null);
      this.$guest_api
        .get("/l-Doc/" + s)
        .then((response) => {
          if (response) {
            console.log(response.data.data);
            this.wasteDocuments = response.data.data;
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async createImg_link() {
      let desSigPic;
      await this.$guest_api
        .get(`/get-des-des_sig_pic/${this.$route.params.tra_id}`)
        .then((res) => {
          desSigPic = res.data.data[0].TR_DESTROY_ID;
          console.log(desSigPic);
        })
        .catch((err) => {
          console.log(err);
        });
      if (desSigPic) {
        this.getUrlOrigin =
          this.$img_url_O + `/${this.$route.params.tra_id}.jpg`;
        this.getUrlRemoval = this.$img_url_R + "/" + desSigPic + ".jpg";
      } else {
        this.getUrlOrigin =
          this.$img_url_O + `/${this.$route.params.tra_id}.jpg`;
        this.getUrlRemoval = this.$img_url_R + "/" + "0" + ".jpg";
      }
      // console.log(this.getUrlOrigin);
      // console.log(this.getUrlRemoval);
    },
    timeTH(date) {
      console.log(date);
      return date
        ? moment(date)
            .add(543, "year")
            .locale("th")
            .format("LL")
        : "";
    },
    printDoc() {
      console.log("%c Print Doc start  ", "color:green;font-weight:600;");
      this.list_wasteDocument();
      // console.log(this.$route.fullPath);
      console.log(this.wasteDocument.length);
      let check_l = this.wasteDocument.length;
      if (check_l == 1) {
        console.log("[0]");
        this.wasteDocument[0].urlO = this.getUrlOrigin;
        this.wasteDocument[0].urlR = this.getUrlRemoval;
        this.wasteDocument[0].rootURL =
          this.$global_link + this.$route.fullPath;
        this.print_documentpdf_a5(this.wasteDocument[0]);
      } else if (check_l > 1) {
        console.log("[1]");
        this.wasteDocument[1].urlO = this.getUrlOrigin;
        this.wasteDocument[1].urlR = this.getUrlRemoval;
        this.wasteDocument[1].rootURL =
          this.$global_link + this.$route.fullPath;
        this.print_documentpdf_a5(this.wasteDocument[1]);
      }

      // console.log(this.wasteDocument.length - 2);
      // console.log(this.wasteDocument[0]);
      // console.log('%c Print Doc end  ','color:red;font-weight:600;');
      //this.print_documentpdf_a5(this.wasteDocument[0]);
    },
    async waste_documentpdf(item) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await waste_document(item)).open();
    },
    async print_documentpdf_a5(item) {
      pdfMake.vfs = pdfFonts.pdfMake.vfs;
      pdfMake.fonts = {
        THSarabunNew: {
          normal: "THSarabunNew.ttf",
          bold: "THSarabunNew Bold.ttf",
          italics: "THSarabunNew Italic.ttf",
          bolditalics: "THSarabunNew BoldItalic.ttf",
        },
        Roboto: {
          normal: "Roboto-Regular.ttf",
          bold: "Roboto-Medium.ttf",
          italics: "Roboto-Italic.ttf",
          bolditalics: "Roboto-MediumItalic.ttf",
        },
      };

      pdfMake.createPdf(await print_document_a5(item,this.$AppName)).open();
    },
    isMobile() {
      var check = false;
      (function(a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);

      return check;
    },
  },
};
</script>
